export default __webpack_public_path__ + "static/media/icon_entrepreneur.499bad24.svg";